import { addStyles } from '../../../components/theme';
import { T, Translate } from '../../../i18n';
import type { MithrilVNode } from '../../../mithril';
import { m } from '../../../mithril';
import { ExportNotificationDetailCtrl } from './export.notification.detail.ctrl';
import { CSS, Style } from './export.notification.detail.style';

addStyles(Style);

const MessageCodeTranslations: { [code: string]: T } = {
	required: T.NOTIFICATION_CODE_REQUIRED,
	default: T.NOTIFICATION_CODE_DEFAULT,
	invalid: T.NOTIFICATION_CODE_INVALID,
	unknown: T.NOTIFICATION_CODE_UNKNOWN,
	other: T.EMPTY,
	reason_only: T.EMPTY,
};

function view(ctrl: ExportNotificationDetailCtrl): MithrilVNode {
	const messageCode = ctrl.getMessageCode();
	const codeTranslateToken = MessageCodeTranslations[messageCode] || MessageCodeTranslations.UNKNOWN!;
	const reasonText = ctrl.getReason();

	//Only states the reasonText
	if (messageCode === 'reason_only') {
		return m('li', { className: CSS.container }, [
			m('span', { className: CSS.reason }, reasonText),
			ctrl.hasDefaultValue() ? m('span', { className: CSS.default }, ` (${ctrl.getDefaultValue()})`) : null,
		]);
	}

	const codeText = Translate(codeTranslateToken);
	let reason = codeText ? ' ' + codeText : '';
	if (reasonText) {
		reason = reason ? `${reason} - ${reasonText}` : ` ${reasonText}`;
	}

	const fieldPath = ctrl.getFieldPath();
	const useRecursivePath = !ctrl.customizedFieldTitle && fieldPath.length > 0;
	return m('li', { className: CSS.container }, [
		m('span', { className: CSS.field }, ctrl.getFieldName()),
		m(
			'span',
			{ className: CSS.form },
			useRecursivePath ? ` ${Translate(T.NOTIFICATION_IN, fieldPath.join(' / '))}` : null
		),
		m('span', { className: CSS.reason }, reason),
		ctrl.hasDefaultValue() ? m('span', { className: CSS.default }, ` (${ctrl.getDefaultValue()})`) : null,
	]);
}

export const ExportNotificationDetail = { view };
